function initInstagramSlider() {
  $(".instagram-slider.enable-insatgram-feed-slider").each(function () {
    const $slider = $(this);
    const $items = $slider.find(".instagram-slider-items");

    // Read attributes from the slider
    const desktopColumns = parseFloat($slider.attr("data-column")) || 6;

   

    if ($items.length > desktopColumns) {
      // Ensure the slider is fully loaded before initializing
    
        // If already initialized, destroy it first
        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("unslick");
        }

        $slider.slick({
          infinite: false,
          slidesToShow: desktopColumns,
          slidesToScroll: 1,

          prevArrow:
            '<div class="slick-prev"><svg class="icon--icon-prev" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="m4 10l9 9l1.4-1.5L7 10l7.4-7.5L13 1z"/></svg></div>',
          nextArrow:
            '<div class="slick-next"><svg class="icon--icon-next" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="M7 1L5.6 2.5L13 10l-7.4 7.5L7 19l9-9z"/></svg></div>',
          responsive: [
            {
              breakpoint: 2000,
              settings: {
                infinite: true,
                centerMode: true,
                centerPadding: "100px",
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 768,
              settings: { slidesToShow: 2 },
            },
          ],
        });
      
    } else {
      // Destroy if already slicked and now too few items
      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }
    }
  });
}

$(document).ready(function () {
  // Delay initialization to ensure the DOM is ready
  setTimeout(function () {
    initInstagramSlider();
   
  }, 500);
});

// Initialize slider on events triggered by Shopify's dynamic content
if (Shopify.designMode) {
  const delayedInit = () => setTimeout(initInstagramSlider, 300);

  document.addEventListener("shopify:section:load", delayedInit);
  document.addEventListener("shopify:section:select", delayedInit);
  document.addEventListener("shopify:section:deselect", delayedInit);
  document.addEventListener("shopify:block:select", delayedInit);
  document.addEventListener("shopify:block:deselect", delayedInit);
  document.addEventListener("shopify:section:unload", delayedInit);
}
